import React from 'react'
import { cx } from '@emotion/css'
import {
  MatchedSearchableItem,
  SearchableItem
} from './SelectEntitiesForm.types'
import { Box, Flex, Checkbox } from 'front-end/src/components'
import { ItemDecorationComponent } from 'front-end/src/components/common/selectEntitiesForm/ItemDecorationComponent'
import { HighlightMatchedString } from 'front-end/src/components/common/selectEntitiesForm/HighlightMatchedString'
import { fontSizes } from 'front-end/src/components/chakraThemeExtension'
import { partition } from 'lodash'
import { MAIN_SEARCHABLE_ITEM_TEXT_PROPERTY_KEY } from './FuzzyResourcesFilter'

type SelectResourcesModalItemProps = {
  matchedItem: MatchedSearchableItem
  handleSelect: (id: SearchableItem['id']) => void
  isSelected: boolean
}

export const MatchedEntity: React.FC<SelectResourcesModalItemProps> = ({
  matchedItem,
  handleSelect,
  isSelected
}) => {
  const select = React.useCallback(
    (ev: React.ChangeEvent | React.MouseEvent) => {
      ev.preventDefault()
      handleSelect(matchedItem.item.id)
    },
    [matchedItem.item.id, handleSelect]
  )

  const [matchedMainText, matchedDecorationText] = React.useMemo(() => {
    return partition(
      matchedItem.matches,
      (m) => m.key === MAIN_SEARCHABLE_ITEM_TEXT_PROPERTY_KEY
    ).map((ms) => ms.map((m) => m.indices))
  }, [matchedItem.matches])

  const decoration = (
    <ItemDecorationComponent
      item={matchedItem.item}
      matches={matchedDecorationText}
    />
  )

  return (
    <Box
      key={matchedItem.item.id}
      className={cx('List__Row narrow', {
        active: isSelected
      })}
      onClick={select}
    >
      <Flex alignItems="center" width="100%">
        <Checkbox
          aria-label="Selected"
          isChecked={isSelected}
          onChange={select}
        />
        <Box
          textAlign="left"
          marginLeft="1rem"
          overflow="hidden"
          overflowWrap="normal"
        >
          <HighlightMatchedString
            text={matchedItem.item.text}
            matches={matchedMainText}
          />
          {decoration && (
            <Box
              fontSize={fontSizes.sm}
              textColor="grey.mid"
              whiteSpace="nowrap"
            >
              {decoration}
            </Box>
          )}
        </Box>
      </Flex>
    </Box>
  )
}
